import { useEffect, useState } from 'react'

export const ToggleSwitchRenderer = (props) => {
  const [checked, setChecked] = useState(props.value);

  useEffect(() => {
    setChecked(props.value); // Update state  when props.value changes
  }, [props.value]);

  const handleChange = (e) => {
    setChecked(e.target.checked); // Update internal state immediately
    props.colDef.cellEditorParams.handleCellChange(props.node.data, props.colDef.field, e.target.checked);
  };

  return (
    <input
      type="checkbox"
      checked={checked}
      onChange={handleChange}
    />
  );
};